import { combineReducers } from 'redux'

import Actions from './actions'
import itoISkipInsurance from './reducers/ItoISkipInsurance'
import acceptContractStatus from './reducers/acceptContractStatus'
import acceptEToIOfferStatus from './reducers/acceptEToIOfferStatus'
import acceptFTRequestStatus from './reducers/acceptFTRequestStatus'
import acceptIToIOfferStatus from './reducers/acceptIToIOfferStatus'
import acceptLaborerAuthRequestStatus from './reducers/acceptLaborerAuthRequestStatus'
import acceptLaborerEditListingRequest from './reducers/acceptLaborerEditListingRequest'
import acceptLaborerListingRequest from './reducers/acceptLaborerListingRequest'
import acceptLaborerTransferRequestStatus from './reducers/acceptLaborerTransferRequestStatus'
import acceptListingOffer from './reducers/acceptListingOffer'
import acceptOfferRequestStatus from './reducers/acceptOfferRequestStatus'
import acceptSalaryPayment from './reducers/acceptSalaryPayment'
import acceptanceRates from './reducers/acceptanceRates'
import accessibilityTools from './reducers/accessibilityTools'
import addComplaintMissingAttachmentStatus from './reducers/addComplaintMissingAttachmentStatus'
import agriculturalRegisterationFile from './reducers/agriculturalRegisterationFile'
import agriculturalSubmission from './reducers/agriculturalSubmission'
import allMarketOffers from './reducers/allMarketOffers'
import alternativeVisaEligibility from './reducers/alternativeVisaEligibility'
import alternativeVisaFlow from './reducers/alternativeVisaFlow'
import approveLaborerAuthAppendix from './reducers/approveLaborerAuthAppendix'
import approveLaborerWorkRefusalRequestStatus from './reducers/approveLaborerWorkRefusalRequestStatus'
import arrivalCities from './reducers/arrivalCities'
import auth from './reducers/auth'
import authBanner from './reducers/authBanner'
import authContract from './reducers/authContract'
import authContractDraft from './reducers/authContractDraft'
import authContractPdf from './reducers/authContractPdf'
import authFlow from './reducers/authFlow'
import authLaborerContractPdf from './reducers/authLaborerContractPdf'
import authPendingAppendix from './reducers/authPendingAppendix'
import authPendingLaborerAppendix from './reducers/authPendingLaborerAppendix'
import authRejectionReasonList from './reducers/authRejectionReasonList'
import availableVisas from './reducers/availableVisas'
import banksInfo from './reducers/banksInfo'
import banksList from './reducers/banksList'
import cancelContractAuthAppendixStatus from './reducers/cancelContractAuthAppendixStatus'
import cancelContractAuthRequestStatus from './reducers/cancelContractAuthRequestStatus'
import cancelContractStatus from './reducers/cancelContractStatus'
import cancelEToIContractStatus from './reducers/cancelEToIContractStatus'
import cancelFTRequestStatus from './reducers/cancelFTRequestStatus'
import cancelLaborerReport from './reducers/cancelLaborerReport'
import cancelListingLaborerCV from './reducers/cancelListingLaborerCV'
import cancelReportRunawayLaborerStatus from './reducers/cancelReportRunawayLaborerStatus'
import cancelRequestStatus from './reducers/cancelRequestStatus'
import changePasswordStatus from './reducers/changePasswordStatus'
import checkCaptchaStatus from './reducers/checkCaptchaStatus'
import checkDirectTransfersCount from './reducers/checkDirectTransfersCount'
import checkFeesExemption from './reducers/checkFeesExemption'
import checkItoITransfersCount from './reducers/checkItoITransfersCount'
import checkLaborerHasReport from './reducers/checkLaborerHasReport'
import checkNafath from './reducers/checkNafath'
import complaintInquiryStatus from './reducers/complaintInquiryStatus'
import complaintsRating from './reducers/complaintsRating'
import complaintsRatingV2 from './reducers/complaintsRatingV2'
import consultancyTypesList from './reducers/consultancyTypesList'
import contractAuthAppendix from './reducers/contractAuthAppendix'
import contractAuthDetailedRequest from './reducers/contractAuthDetailedRequest'
import contractAuthEmployerLaborers from './reducers/contractAuthEmployerLaborers'
import contractAuthRequestsList from './reducers/contractAuthRequestsList'
import contractInfo from './reducers/contractInfo'
import contractInvoiceFile from './reducers/contractInvoiceFile'
import contractLegalText from './reducers/contractLegalText'
import contractRequestInfo from './reducers/contractRequestInfo'
import contractRequestsList from './reducers/contractRequestsList'
import cookiesDisclaimerBar from './reducers/cookiesDisclaimerBar'
import createAgent from './reducers/createAgent'
import createComplaintStatus from './reducers/createComplaintStatus'
import createConsultancyRequest from './reducers/createConsultancyRequest'
import createContractAuthAppendixStatus from './reducers/createContractAuthAppendixStatus'
import createContractAuthRequest from './reducers/createContractAuthRequest'
import createContractAuthRequestStatus from './reducers/createContractAuthRequestStatus'
import createDomesticRequest from './reducers/createDomesticRequest'
import createGovernmentRequest from './reducers/createGovernmentRequest'
import createInterview from './reducers/createInterview'
import createNoticeStatus from './reducers/createNoticeStatus'
import createRefundTicketStatus from './reducers/createRefundTicketStatus'
import cvByPreferences from './reducers/cvByPreferences'
import cvReportStatus from './reducers/cvReportStatus'
import delayedContractCounts from './reducers/delayedContractCounts'
import disabilityVIsaEligibility from './reducers/disabilityVIsaEligibility'
import disabilityVisaFlow from './reducers/disabilityVisaFlow'
import disableListingRequest from './reducers/disableListingRequest'
import domesticTransferCreating from './reducers/domesticTransferCreating'
import domesticTransferForm from './reducers/domesticTransferForm'
import downloadHistory from './reducers/downloadHistory'
import eTawtheeqContractStatus from './reducers/eTawtheeqContractStatus'
import eToICancelReplacementStatus from './reducers/eToICancelReplacementStatus'
import eToIFinancialDocuments from './reducers/eToIFinancialDocuments'
import eToIInvoiceFile from './reducers/eToIInvoiceFile'
import eToILegacyRequests from './reducers/eToILegacyRequests'
import eToIReplaceWorkerStatus from './reducers/eToIReplaceWorkerStatus'
import eToIRequest from './reducers/eToIRequest'
import eToIRequests from './reducers/eToIRequests'
import eToITransferWorkerStatus from './reducers/eToITransferWorkerStatus'
import eligibleWorkers from './reducers/eligibleWorkers'
import employerLaborerDetails from './reducers/employerLaborerDetails'
import employerLaborersList from './reducers/employerLaborersList'
import extendContractStatus from './reducers/extendContractStatus'
import extendListingRequest from './reducers/extendListingRequest'
import farmerTransfer from './reducers/farmerTransfer'
import farmerTransferEligibility from './reducers/farmerTransferEligibility'
import farmerTransferability from './reducers/farmerTransferability'
import farmerVisaCancelationStatus from './reducers/farmerVisaCancelationStatus'
import farmerVisaEligibility from './reducers/farmerVisaEligibility'
import farmerVisaFlow from './reducers/farmerVisaFlow'
import farmerVisaRequests from './reducers/farmerVisaRequests'
import getEligibleLaborers from './reducers/getEligibleLaborers'
import getPassportCopy from './reducers/getPassportCopy'
import governmentAgenciesList from './reducers/governmentAgenciesList'
import hideWelcomePopup from './reducers/hideWelcomePopup'
import iToERequestActions from './reducers/iToERequestActions'
import iToERequestDetails from './reducers/iToERequestDetails'
import iToERequests from './reducers/iToERequests'
import iToIBill from './reducers/iToIBill'
import iToIFinancialDocuments from './reducers/iToIFinancialDocuments'
import iToIInvoiceFile from './reducers/iToIInvoiceFile'
import iToILaborerDetails from './reducers/iToILaborerDetails'
import iToILaborerList from './reducers/iToILaborerList'
import iToIRequestDetails from './reducers/iToIRequestDetails'
import iToIRequestsList from './reducers/iToIRequestsList'
import iToISuggestedCost from './reducers/iToISuggestedCost'
import iToITransferEligibility from './reducers/iToITransferEligibility'
import iToITransferRequestStatus from './reducers/iToITransferRequestStatus'
import infoAboutFarmerRequest from './reducers/infoAboutFarmerRequest'
import interview from './reducers/interview'
import interviewBill from './reducers/interviewBill'
import interviewPdfReport from './reducers/interviewPdfReport'
import interviewResult from './reducers/interviewResult'
import interviewsList from './reducers/interviewsList'
import isUserHasVisas from './reducers/isUserHasVisas'
import issueNewDisabilityVisaStatus from './reducers/issueNewDisabilityVisaStatus'
import issueNewFarmerTransferStatus from './reducers/issueNewFarmerTransferStatus'
import issueNewFarmerVisaStatus from './reducers/issueNewFarmerVisaStatus'
import issueNewVisaRequestStatus from './reducers/issueNewVisaRequestStatus'
import itoITameeniInsuranceRedirectUrl from './reducers/itoITameeniInsuranceRedirectUrl'
import kabiServiceBars from './reducers/kabiServiceBars'
import laborOffices from './reducers/laborOffices'
import laborerAuthAppendixDetails from './reducers/laborerAuthAppendixDetails'
import laborerAuthAppendixList from './reducers/laborerAuthAppendixList'
import laborerAuthContractText from './reducers/laborerAuthContractText'
import laborerAuthRequestDetails from './reducers/laborerAuthRequestDetails'
import laborerAuthRequestList from './reducers/laborerAuthRequestList'
import laborerComplaintDetails from './reducers/laborerComplaintDetails'
import laborerCreationTicket from './reducers/laborerCreationTicket'
import laborerIToIRelativeInfo from './reducers/laborerIToIRelativeInfo'
import laborerInfo from './reducers/laborerInfo'
import laborerInterviewFlow from './reducers/laborerInterviewFlow'
import laborerInterviewPros from './reducers/laborerInterviewPros'
import laborerListingRequests from './reducers/laborerListingRequests'
import laborerLoginStatus from './reducers/laborerLoginStatus'
import laborerOtpVerifyStatus from './reducers/laborerOtpVerifyStatus'
import laborerPhoneForContractAuthStatus from './reducers/laborerPhoneForContractAuthStatus'
import laborerRefreshToken from './reducers/laborerRefreshToken'
import laborerSalaryChangeRequestDetails from './reducers/laborerSalaryChangeRequestDetails'
import laborerSalaryChangeRequests from './reducers/laborerSalaryChangeRequests'
import laborerSupportAttachments from './reducers/laborerSupportAttachments'
import laborerSupportTickets from './reducers/laborerSupportTickets'
import laborerTransactionDetails from './reducers/laborerTransactionDetails'
import laborerTransactionsList from './reducers/laborerTransactionsList'
import laborerTransferDetails from './reducers/laborerTransferDetails'
import laborerTransfersList from './reducers/laborerTransfersList'
import laborerWorkRefusalRequestDetails from './reducers/laborerWorkRefusalRequestDetails'
import laborerWorkRefusalRequests from './reducers/laborerWorkRefusalRequests'
import labors from './reducers/labors'
import lang from './reducers/language'
import languageModal from './reducers/languageModal'
import lastFourVisas from './reducers/lastFourVisas'
import listLaborerCV from './reducers/listLaborerCV'
import listLaborerEligibility from './reducers/listLaborerEligibility'
import listLaborerFilter from './reducers/listLaborerFilter'
import listingCVsList from './reducers/listingCVsList'
import listingLaborerCVRequest from './reducers/listingLaborerCVRequest'
import listingOffer from './reducers/listingOffer'
import listingRequest from './reducers/listingRequest'
import listingRequestList from './reducers/listingRequestList'
import locationDetails from './reducers/locationDetails'
import loginNafath from './reducers/loginNafath'
import maarofaBar from './reducers/maarofaBar'
import maarofaOffices from './reducers/maarofaOffices'
import maarofaRequest from './reducers/maarofaRequest'
import maarofaRequestStatus from './reducers/maarofaRequestStatus'
import maarofaServiceTemplate from './reducers/maarofaServiceTemplate'
import managerAuthStatus from './reducers/managerAuthStatus'
import managerInfo from './reducers/managerInfo'
import marketFilter from './reducers/marketFilter'
import marketOffers from './reducers/marketOffers'
import marketSelectedOffers from './reducers/marketSelectedOffers'
import marketSelectedVipPros from './reducers/marketSelectedVipPros'
import mobileVerify from './reducers/mobileVerify'
import mobileVerifyStatus from './reducers/mobileVerifyStatus'
import najmRedirectionUrlStatus from './reducers/najmRedirectionUrlStatus'
import nationalities from './reducers/nationalities'
import newNoticeFlow from './reducers/newNoticeFlow'
import notice from './reducers/notice'
import noticeAvailability from './reducers/noticeAvailability'
import notices from './reducers/notices'
import occupationDescriptions from './reducers/occupationDescriptions'
import occupations from './reducers/occupations'
import officeInfo from './reducers/officeInfo'
import onlinePaymentVisa from './reducers/onlinePaymentVisa'
import outdatedIBAN from './reducers/outdatedIBAN'
import payForEContractStatus from './reducers/payForEContractStatus'
import payForEToIRequestStatus from './reducers/payForEToIRequestStatus'
import payForFarmerTransferStatus from './reducers/payForFarmerTransferStatus'
import payForFarmerVisaStatus from './reducers/payForFarmerVisaStatus'
import payForIToIRequestStatus from './reducers/payForIToIRequestStatus'
import payForInterviewStatus from './reducers/payForInterviewStatus'
import payNotice from './reducers/payNotice'
import paymentInfo from './reducers/paymentInfo'
import preferencesForm from './reducers/preferencesForm'
import preselectedForm from './reducers/preselectedForm'
import priceRange from './reducers/priceRange'
import proPerformance from './reducers/proPerformance'
import proPerformanceFilter from './reducers/proPerformanceFilter'
import proPerformanceOverall from './reducers/proPerformanceOverall'
import proRecruitedServiceAddons from './reducers/proRecruitedServiceAddons'
import proServiceAddons from './reducers/proServiceAddons'
import proServiceAddonsAll from './reducers/proServiceAddonsAll'
import proServiceDetails from './reducers/proServiceDetails'
import prosStatistic from './reducers/prosStatistic'
import recruitmentDurationRange from './reducers/recruitmentDurationRange'
import recruitmentFilter from './reducers/recruitmentFilter'
import refundDetails from './reducers/refundDetails'
import refundPayFort from './reducers/refundPayFort'
import refundSADAD from './reducers/refundSADAD'
import refundableBills from './reducers/refundableBills'
import regularVisaFlow from './reducers/regularVisaFlow'
import rejectContractStatus from './reducers/rejectContractStatus'
import rejectEToIOfferStatus from './reducers/rejectEToIOfferStatus'
import rejectFTRequestStatus from './reducers/rejectFTRequestStatus'
import rejectIToIOfferStatus from './reducers/rejectIToIOfferStatus'
import rejectLaborerAuthAppendix from './reducers/rejectLaborerAuthAppendix'
import rejectLaborerAuthRequestStatus from './reducers/rejectLaborerAuthRequestStatus'
import rejectLaborerEditListingRequest from './reducers/rejectLaborerEditListingRequest'
import rejectLaborerListingRequest from './reducers/rejectLaborerListingRequest'
import rejectLaborerTransferRequestStatus from './reducers/rejectLaborerTransferRequestStatus'
import rejectLaborerWorkRefusalRequestStatus from './reducers/rejectLaborerWorkRefusalRequestStatus'
import rejectListingOffer from './reducers/rejectListingOffer'
import rejectOfferStatus from './reducers/rejectOfferStatus'
import rejectSalaryPayment from './reducers/rejectSalaryPayment'
import rejectionReasonsList from './reducers/rejectionReasonsList'
import replyLaborerSalaryChangeRequestStatus from './reducers/replyLaborerSalaryChangeRequestStatus'
import removeAgentStatus from './reducers/removeAgentStatus'
import removeFromPilotList from './reducers/removeFromPilotList'
import replaceVisasStatus from './reducers/replaceVisasStatus'
import replaceableVisa from './reducers/replaceableVisa'
import reportRunawayLaborerStatus from './reducers/reportRunawayLaborerStatus'
import requestIdForContractIdStatus from './reducers/requestIdForContractIdStatus'
import resendEToIRequestStatus from './reducers/resendEToIRequestStatus'
import respondToComplaintSolutionStatus from './reducers/respondToComplaintSolutionStatus'
import respondToOfficeComplaintStatus from './reducers/respondToOfficeComplaintStatus'
import resubmitListingRequest from './reducers/resubmitListingRequest'
import runawaysList from './reducers/runawaysList'
import saveUserProfileStatus from './reducers/saveUserProfileStatus'
import selectListingCV from './reducers/selectListingCV'
import selectVipProStatus from './reducers/selectVipProStatus'
import sendAbsherUpdateMobileStatus from './reducers/sendAbsherUpdateMobileStatus'
import sendLaborerRelativeInfo from './reducers/sendLaborerRelativeInfo'
import sendLaborerReport from './reducers/sendLaborerReport'
import sendOtpUpdateMobileStatus from './reducers/sendOtpUpdateMobileStatus'
import setNewPrimaryAddress from './reducers/setNewPrimaryAddress'
import showComplaintsSurvey from './reducers/showComplaintsSurvey'
import simpleAuthContractInfo from './reducers/simpleAuthContractInfo'
import skills from './reducers/skills'
import specialServicesList from './reducers/specialServicesList'
import specialServicesRequest from './reducers/specialServicesRequest'
import submitEditListingRequest from './reducers/submitEditListingRequest'
import submitFeesExemptionStatus from './reducers/submitFeesExemptionStatus'
import submitOfflinePayment from './reducers/submitOfflinePayment'
import submitWataniSurveyStatus from './reducers/submitWataniSurveyStatus'
import supportTicket from './reducers/supportTicket'
import supportTickets from './reducers/supportTickets'
import supportTicketsGuest from './reducers/supportTicketsGuest'
import surveyQuestions from './reducers/surveyQuestions'
import tameeniRedirectionUrlStatus from './reducers/tameeniRedirectionUrlStatus'
import ticket from './reducers/ticket'
import ticketsList from './reducers/ticketsList'
import updateLaborerMobileNumberStatus from './reducers/updateLaborerMobileNumberStatus'
import updateLaborsStatus from './reducers/updateLaborsStatus'
import updateNationalAddress from './reducers/updateNationalAddress'
import uploadDisabilityProofStatus from './reducers/uploadDisabilityProofStatus'
import uploadPassportCopy from './reducers/uploadPassportCopy'
import uploadSpecialServiceFile from './reducers/uploadSpecialServiceFile'
import uploadVisasFilesStatus from './reducers/uploadVisasFilesStatus'
import userVisaEligibility from './reducers/userVisaEligibility'
import vatInfo from './reducers/vatInfo'
import verifyAbsherUpdateMobileStatus from './reducers/verifyAbsherUpdateMobileStatus'
import verifyAgent from './reducers/verifyAgent'
import verifyOtpUpdateMobileStatus from './reducers/verifyOtpUpdateMobileStatus'
import vipContractRequest from './reducers/vipContractRequest'
import vipPreselectedInfo from './reducers/vipPreselectedInfo'
import vipPros from './reducers/vipPros'
import vipRecruitmentFilter from './reducers/vipRecruitmentFilter'
import vipVisaList from './reducers/vipVisaList'
import visaCancellationStatus from './reducers/visaCancellationStatus'
import visaInfo from './reducers/visaInfo'
import visaInquiryStatus from './reducers/visaInquiryStatus'
import visaInvoiceFile from './reducers/visaInvoiceFile'
import visaIssuePlaces from './reducers/visaIssuePlaces'
import visaIssueRequestInfo from './reducers/visaIssueRequestInfo'
import visaIssueRequestsList from './reducers/visaIssueRequestsList'
import visaPdfUrl from './reducers/visaPdfUrl'
import visaWithContractRequest from './reducers/visaWithContractRequest'
import visasList from './reducers/visasList'
import workers from './reducers/workers'
import wpsCommitmentsStatistic from './reducers/wpsCommitmentsStatistic'
import wpsCurrentLaborer from './reducers/wpsCurrentLaborer'
import wpsCurrentTransaction from './reducers/wpsCurrentTransaction'
import wpsLaborerTransactions from './reducers/wpsLaborerTransactions'
import wpsLaborersList from './reducers/wpsLaborersList'
import laborerGetWpsTransactionList from './reducers/laborerGetWpsTransactionList'
import laborerGetWpsTransactionInfo from './reducers/laborerGetWpsTransactionInfo'
import registerCheckInfo from './reducers/registerCheckInfo'
import registerCheckNafath from './reducers/registerCheckNafath'
import setMobileStatus from './reducers/setMobileStatus'
import verifyMobileStatus from './reducers/verifyMobileStatus'
import registerChangeMobileStatus from './reducers/registerChangeMobileStatus'
import registerVerifyMobileStatus from './reducers/registerVerifyMobileStatus'
import sendUpdatePasswordOtpStatus from './reducers/sendUpdatePasswordOtpStatus'
import updatePasswordOptVerifyStatus from './reducers/updatePasswordOptVerifyStatus'
import updatePasswordStatus from './reducers/updatePasswordStatus'
import verifyPasswordStatus from './reducers/verifyPasswordStatus'
import sendUpdateMobileOtpStatus from './reducers/sendUpdateMobileOtpStatus'
import verifyUpdateMobileOtpStatus from './reducers/verifyUpdateMobileOtpStatus'
import checkLaborerSurveyEligibility from './reducers/checkLaborerSurveyEligibility'
import getLaborerSurveyQuestions from './reducers/getLaborerSurveyQuestions'
import getLaborerSubmitedRatings from './reducers/getLaborerSubmitedRatings'
import submitLaborerRating from './reducers/submitLaborerRating'
import checkLaborerProSurveyEligibility from './reducers/checkLaborerProSurveyEligibility'
import submitLaborerProSurvey from './reducers/submitLaborerProSurvey'
import getLaborerEToIRequests from './reducers/getLaborerEToIRequests'
import getLaborerEToIRequestById from './reducers/getLaborerEToIRequestById'
import submitReplyForLaborerEToIRequest from './reducers/submitReplyForLaborerEToIRequest'

const appReducers = {
  acceptContractStatus,
  acceptEToIOfferStatus,
  acceptFTRequestStatus,
  acceptIToIOfferStatus,
  acceptLaborerTransferRequestStatus,
  approveLaborerWorkRefusalRequestStatus,
  acceptOfferRequestStatus,
  accessibilityTools,
  addComplaintMissingAttachmentStatus,
  agriculturalRegisterationFile,
  agriculturalSubmission,
  allMarketOffers,
  alternativeVisaEligibility,
  alternativeVisaFlow,
  arrivalCities,
  auth,
  authBanner,
  authFlow,
  availableVisas,
  banksInfo,
  banksList,
  cancelContractAuthRequestStatus,
  cancelContractStatus,
  cancelEToIContractStatus,
  cancelFTRequestStatus,
  cancelRequestStatus,
  cancelReportRunawayLaborerStatus,
  changePasswordStatus,
  checkCaptchaStatus,
  checkFeesExemption,
  checkLaborerSurveyEligibility,
  checkLaborerProSurveyEligibility,
  checkNafath,
  complaintInquiryStatus,
  complaintsRating,
  complaintsRatingV2,
  contractAuthDetailedRequest,
  contractAuthEmployerLaborers,
  contractAuthRequestsList,
  contractInfo,
  contractRequestInfo,
  contractRequestsList,
  createAgent,
  createComplaintStatus,
  createContractAuthRequest,
  createContractAuthRequestStatus,
  createNoticeStatus,
  createRefundTicketStatus,
  cvByPreferences,
  cvReportStatus,
  disabilityVIsaEligibility,
  disabilityVisaFlow,
  domesticTransferCreating,
  domesticTransferForm,
  downloadHistory,
  eligibleWorkers,
  eTawtheeqContractStatus,
  eToICancelReplacementStatus,
  eToIFinancialDocuments,
  eToILegacyRequests,
  eToIReplaceWorkerStatus,
  eToIRequest,
  eToIRequests,
  eToITransferWorkerStatus,
  extendContractStatus,
  farmerTransfer,
  farmerTransferability,
  farmerTransferEligibility,
  farmerVisaCancelationStatus,
  farmerVisaEligibility,
  farmerVisaFlow,
  farmerVisaRequests,
  getEligibleLaborers,
  getLaborerEToIRequestById,
  getLaborerEToIRequests,
  getLaborerSurveyQuestions,
  getLaborerSubmitedRatings,
  infoAboutFarmerRequest,
  issueNewDisabilityVisaStatus,
  issueNewFarmerTransferStatus,
  issueNewFarmerVisaStatus,
  issueNewVisaRequestStatus,
  isUserHasVisas,
  iToERequestActions,
  iToERequestDetails,
  iToERequests,
  iToIBill,
  iToIFinancialDocuments,
  iToIInvoiceFile,
  iToILaborerDetails,
  iToILaborerList,
  iToIRequestDetails,
  iToIRequestsList,
  iToITransferEligibility,
  iToITransferRequestStatus,
  itoISkipInsurance,
  iToISuggestedCost,
  itoITameeniInsuranceRedirectUrl,
  laborerGetWpsTransactionInfo,
  laborerGetWpsTransactionList,
  laborerInfo,
  laborerIToIRelativeInfo,
  laborerLoginStatus,
  laborerOtpVerifyStatus,
  laborerPhoneForContractAuthStatus,
  laborerRefreshToken,
  laborerSalaryChangeRequestDetails,
  laborerSalaryChangeRequests,
  laborerTransferDetails,
  laborerTransfersList,
  laborerWorkRefusalRequestDetails,
  laborerWorkRefusalRequests,
  laborOffices,
  labors,
  lang,
  lastFourVisas,
  locationDetails,
  loginNafath,
  cookiesDisclaimerBar,
  maarofaBar,
  maarofaOffices,
  maarofaRequest,
  maarofaRequestStatus,
  maarofaServiceTemplate,
  marketFilter,
  marketOffers,
  marketSelectedOffers,
  mobileVerify,
  mobileVerifyStatus,
  najmRedirectionUrlStatus,
  nationalities,
  newNoticeFlow,
  notice,
  noticeAvailability,
  notices,
  occupationDescriptions,
  occupations,
  officeInfo,
  onlinePaymentVisa,
  outdatedIBAN,
  payForEContractStatus,
  payForEToIRequestStatus,
  payForFarmerTransferStatus,
  payForFarmerVisaStatus,
  payForIToIRequestStatus,
  payNotice,
  paymentInfo,
  preferencesForm,
  preselectedForm,
  priceRange,
  proServiceDetails,
  prosStatistic,
  recruitmentDurationRange,
  recruitmentFilter,
  refundDetails,
  refundPayFort,
  refundSADAD,
  refundableBills,
  registerCheckInfo,
  registerCheckNafath,
  registerChangeMobileStatus,
  registerVerifyMobileStatus,
  regularVisaFlow,
  rejectContractStatus,
  rejectEToIOfferStatus,
  rejectFTRequestStatus,
  rejectLaborerTransferRequestStatus,
  rejectLaborerWorkRefusalRequestStatus,
  rejectOfferStatus,
  rejectionReasonsList,
  replyLaborerSalaryChangeRequestStatus,
  rejectIToIOfferStatus,
  replaceVisasStatus,
  replaceableVisa,
  reportRunawayLaborerStatus,
  requestIdForContractIdStatus,
  resendEToIRequestStatus,
  respondToComplaintSolutionStatus,
  respondToOfficeComplaintStatus,
  runawaysList,
  setMobileStatus,
  saveUserProfileStatus,
  sendAbsherUpdateMobileStatus,
  sendLaborerRelativeInfo,
  sendOtpUpdateMobileStatus,
  setNewPrimaryAddress,
  showComplaintsSurvey,
  skills,
  submitFeesExemptionStatus,
  submitLaborerProSurvey,
  submitReplyForLaborerEToIRequest,
  submitWataniSurveyStatus,
  supportTicket,
  supportTickets,
  supportTicketsGuest,
  surveyQuestions,
  ticket,
  ticketsList,
  updateLaborsStatus,
  updateNationalAddress,
  uploadDisabilityProofStatus,
  uploadVisasFilesStatus,
  userVisaEligibility,
  vatInfo,
  verifyAbsherUpdateMobileStatus,
  verifyAgent,
  verifyMobileStatus,
  verifyOtpUpdateMobileStatus,
  visaCancellationStatus,
  visaInfo,
  visaInquiryStatus,
  visaInvoiceFile,
  visaIssuePlaces,
  visaIssueRequestInfo,
  visaIssueRequestsList,
  visaWithContractRequest,
  visasList,
  visaPdfUrl,
  workers,
  wpsCommitmentsStatistic,
  wpsCurrentLaborer,
  wpsCurrentTransaction,
  wpsLaborersList,
  wpsLaborerTransactions,
  removeFromPilotList,
  contractAuthAppendix,
  createContractAuthAppendixStatus,
  updateLaborerMobileNumberStatus,
  eToIInvoiceFile,
  cancelContractAuthAppendixStatus,
  proServiceAddons,
  proServiceAddonsAll,
  contractInvoiceFile,
  proPerformance,
  proPerformanceOverall,
  proPerformanceFilter,
  acceptanceRates,
  laborerAuthRequestList,
  laborerAuthRequestDetails,
  laborerAuthContractText,
  acceptLaborerAuthRequestStatus,
  rejectLaborerAuthRequestStatus,
  authRejectionReasonList,
  laborerAuthAppendixList,
  laborerAuthAppendixDetails,
  rejectLaborerAuthAppendix,
  approveLaborerAuthAppendix,
  removeAgentStatus,
  vipRecruitmentFilter,
  vipPreselectedInfo,
  simpleAuthContractInfo,
  authContractDraft,
  authLaborerContractPdf,
  authContractPdf,
  authContract,
  vipContractRequest,
  authPendingAppendix,
  authPendingLaborerAppendix,
  tameeniRedirectionUrlStatus,
  delayedContractCounts,
  vipVisaList,
  proRecruitedServiceAddons,
  vipPros,
  marketSelectedVipPros,
  selectVipProStatus,
  managerInfo,
  managerAuthStatus,
  laborerComplaintDetails,
  sendLaborerReport,
  cancelLaborerReport,
  languageModal,
  laborerSupportTickets,
  laborerCreationTicket,
  laborerSupportAttachments,
  checkLaborerHasReport,
  laborerListingRequests,
  acceptLaborerListingRequest,
  rejectLaborerListingRequest,
  listLaborerEligibility,
  listLaborerCV,
  cancelListingLaborerCV,
  listingLaborerCVRequest,
  listLaborerFilter,
  listingCVsList,
  selectListingCV,
  listingRequestList,
  listingRequest,
  submitEditListingRequest,
  sendUpdatePasswordOtpStatus,
  updatePasswordOptVerifyStatus,
  updatePasswordStatus,
  verifyPasswordStatus,
  sendUpdateMobileOtpStatus,
  verifyUpdateMobileOtpStatus,
  extendListingRequest,
  resubmitListingRequest,
  disableListingRequest,
  acceptListingOffer,
  rejectListingOffer,
  listingOffer,
  laborerInterviewFlow,
  laborerInterviewPros,
  uploadPassportCopy,
  acceptLaborerEditListingRequest,
  rejectLaborerEditListingRequest,
  createInterview,
  payForInterviewStatus,
  interviewsList,
  interview,
  interviewPdfReport,
  interviewBill,
  submitLaborerRating,
  submitOfflinePayment,
  laborerTransactionsList,
  laborerTransactionDetails,
  acceptSalaryPayment,
  rejectSalaryPayment,
  employerLaborersList,
  employerLaborerDetails,
  kabiServiceBars,
  interviewResult,
  getPassportCopy,
  checkDirectTransfersCount,
  checkItoITransfersCount,
  specialServicesList,
  governmentAgenciesList,
  consultancyTypesList,
  uploadSpecialServiceFile,
  createGovernmentRequest,
  createConsultancyRequest,
  createDomesticRequest,
  specialServicesRequest,
  hideWelcomePopup,
  contractLegalText,
}

type AppReducer = typeof appReducers
type AppReducerKey = keyof AppReducer

const reducersProcessing = (reducers: AppReducer): AppReducer => {
  const setReducer =
    (reducer: Function, reducerKey: AppReducerKey) =>
    (state: unknown, action: { type: string; payload: Set<keyof RootState> | null }) => {
      const { payload, type } = action
      if (type === Actions.RESET_STATE && payload && payload.has(reducerKey)) {
        return reducer(undefined, action)
      }

      if (type === Actions.RESET_STATE && !payload) return reducer(undefined, action)

      return reducer(state, action)
    }
  return (Object.keys(appReducers) as Array<AppReducerKey>).reduce(
    (acc, curr) => ({ ...acc, [curr]: setReducer(reducers[curr], curr) }),
    {} as AppReducer,
  )
}

const rootReducer = () => combineReducers(reducersProcessing(appReducers))

export type RootState = ReturnType<ReturnType<typeof rootReducer>>

export default rootReducer
